/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import clue from './clue'
import admin from './admin'
import complain from './complain'
import law from './law'
import approve from './approve'
import file from './file'
import others from './others'
// import chartsAndMaps from './charts-and-maps'
// import uiElements from './ui-elements'
// import formAndTable from './forms-and-table'

import * as userData from "@/auth/localStorageUtils.js";

const currentRole = userData.selectedUserRole()

console.log('currentRole', currentRole)

const menuFilter = (role, menus) => {
  return menus.filter(value => {
    if (role.menus.filter(value2 => {
      if (value2.action === value.menu) return value2
    }).length > 0) {
      return value
    }
  })
}

const adminFiltered = menuFilter(currentRole, admin)
const clueFiltered = menuFilter(currentRole, clue)
const complainFiltered = menuFilter(currentRole, complain)
const lawFiltered = menuFilter(currentRole, law)
const approveFiltered = menuFilter(currentRole, approve)
const fileFiltered = menuFilter(currentRole, file)
const othersFiltered = menuFilter(currentRole, others)

// const adminFiltered = admin.filter(value => {
//   if (currentRole.menus.filter(value2 => {
//     if (value2.action === value.menu) return value2
//   }).length > 0) {
//     return value
//   }
// })



// import setting from './setting'
// import clue from './clue'
// Array of sections
export default [
  //...dashboard,
  ...adminFiltered,  
  ...complainFiltered,
  ...clueFiltered,
  ...lawFiltered,
  ...approveFiltered,
  ...fileFiltered,
  ...othersFiltered,
  // ...clue,
  // ...setting,
  //
  // ...uiElements,
  // ...formAndTable,
  // ...chartsAndMaps,
  // ...others
]
